import React, { useEffect, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";

const PTrendsGraph = ({ good = [], scrap = [], categories }) => {
  const [state, setState] = useState({
    chart: {
      type: "spline",
      height: "290px",
      toolbar: {
        show: false,
      },
    },
    credits: {
      enabled: false,
    },
    title: {
      text: null,
    },
    xAxis: {
      categories: categories,
      labels: {
        style: {
          color: "#404040",
          fontSize: "10px",
          fontWeight: "600",
        },
      },
      lineWidth: 0,
    },
    yAxis: {
      // min: 0,
      // max: 100,
      tickAmount: 5,
      title: "",
      labels: {
        format: "{value}",
        style: {
          color: "#404040",
          fontSize: "10px",
          fontWeight: "600",
        },
      },
    },
    plotOptions: {
      series: {
        dataLabels: {
          enabled: false,
        },
      },
    },
    legend: {
      align: "center",
      verticalAlign: "top",
      alignColumns: false,
      itemStyle: {
        fontSize: "11px",
        fontWeight: "600",
      },
      symbolPadding: 0,
      symbolRadius: 0,
      symbol: "sqaure",
    },
    series: [
      {
        name: "Good Parts",
        data: good,
        color: "#0077B6",
        marker: {
          enabled: false,
        },
      },
      {
        name: "Scrap Parts",
        data: scrap,
        color: "#E63946",
        marker: {
          enabled: false,
        },
      },
    ],
  });

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      chart: {
        ...prev.chart,
        height: window.screen.height - window.screen.height / 1.5,
      },
    }));
    // console.log(window.screen.height);
  }, [window.screen.height]);

  return (
    <div id="chart">
      <HighchartsReact highcharts={Highcharts} options={state} />
    </div>
  );
};

export default PTrendsGraph;
